export class BaseAuthorization {
    params;
    constructor(params) {
        this.params = params;
    }
}
